export enum tipoMensaje{
    Confirmacion,
    Informacion,
    Verificacion,
    Error,
    Descarga
}

export enum respuestaMensaje{
    Aceptar,
    Cancelar,
    Cerrar,
    Descargar
}


export interface Mensaje{
    tipo: tipoMensaje;
    mensaje: string;
}